import { Component, Input } from '@angular/core';

@Component({
    selector: 'search-result-company',
    templateUrl: './searchResultCompany.component.html',
    standalone: false
})
export class SearchResultCompanyComponent {
    @Input() result: any;
}
